export default __webpack_public_path__ + "static/media/rover1@3x.b48e5570.png";